import "./checkbox.css";
import { attachPropertiesToComponent } from '../../utils/attach-properties-to-component';
import { Group } from './group';
import { Checkbox } from './checkbox';
export default attachPropertiesToComponent(Checkbox, {
  Group
});